/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Popup_Settings_TitleInputs */

const he_extension_popup_settings_title = /** @type {(inputs: Extension_Popup_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הגדרות`)
};

const en_extension_popup_settings_title = /** @type {(inputs: Extension_Popup_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

/**
* | output |
* | --- |
* | "Settings" |
*
* @param {Extension_Popup_Settings_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const extension_popup_settings_title = /** @type {((inputs?: Extension_Popup_Settings_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Popup_Settings_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_popup_settings_title(inputs)
	return en_extension_popup_settings_title(inputs)
});